// Presentation Layer - Banner de actualización PWA
import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { Button, Text, Surface } from 'react-native-paper';
import { usePWA } from '../hooks/usePWA';

export const PWAUpdateBanner: React.FC = () => {
  const { updateAvailable, applyUpdate } = usePWA();

  if (Platform.OS !== 'web' || !updateAvailable) {
    return null;
  }

  return (
    <Surface style={styles.container} elevation={3}>
      <View style={styles.content}>
        <View style={styles.textContainer}>
          <Text variant="titleSmall" style={styles.title}>
            Nueva versión disponible
          </Text>
          <Text variant="bodySmall" style={styles.description}>
            Hay una actualización lista para instalar
          </Text>
        </View>
        <Button mode="contained" onPress={applyUpdate} compact>
          Actualizar
        </Button>
      </View>
    </Surface>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute' as any,
    top: 16,
    left: 16,
    right: 16,
    borderRadius: 8,
    zIndex: 1000,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    gap: 12,
  },
  textContainer: {
    flex: 1,
  },
  title: {
    fontWeight: '600',
    marginBottom: 4,
  },
  description: {
    opacity: 0.7,
  },
});
